import { NotificationConfig } from './Notification.types';

export const DEFAULT_CONFIG: Pick<NotificationConfig, 'type' | 'autoClose' | 'visibilityTime'> = {
    type: 'informative',
    autoClose: true,
    visibilityTime: 4000,
};
